// src/components/ImageGallery.jsx
import React, { useState } from "react";

function ImageGallery({ items }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const activeItem = activeIndex !== null ? items[activeIndex] : null;

  return (
    <>
      <div className="image-strip">
        {items.map((item, index) => (
          <button
            key={index}
            type="button"
            className="image-tile"
            onClick={() => setActiveIndex(index)}
          >
            {item.src && (
              <img
                className="image-photo"
                src={item.src}
                alt={item.alt || item.label}
              />
            )}
            <span>{item.label}</span>
          </button>
        ))}
      </div>

      {activeItem && (
        <div className="image-modal" onClick={() => setActiveIndex(null)}>
          <div
            className="image-modal-inner"
            onClick={(e) => e.stopPropagation()}
          >
            {activeItem.src ? (
              <img
                className="image-modal-photo"
                src={activeItem.src}
                alt={activeItem.alt || activeItem.label}
              />
            ) : (
              <div className="image-modal-placeholder">
                {activeItem.label}
              </div>
            )}
            <div className="image-modal-caption">
              {activeItem.caption || activeItem.label}
            </div>
            <button
              type="button"
              className="image-modal-close"
              onClick={() => setActiveIndex(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ImageGallery;
